"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _text = require("../text");

var _context = require("../context");

var _utils = require("../utils");

var _constants = require("./constants");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: inline;\n\n  & a {\n    color: ", ";\n    text-decoration: underline;\n    font-weight: ", ";\n  }\n\n  & a:visited {\n    color: ", ";\n  }\n\n  & a:hover {\n    text-decoration: none;\n  }\n\n  & a:focus {\n    outline: ", ";\n    outline-offset: 2px;\n  }\n\n  & a:active {\n    color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// The `display` prop cannot be used due to https://sim.amazon.com/issues/StencilDevelopment-1179
var MessageBannerText = (0, _context.styledWithTheme)(_text.Text.withComponent('div', {
  target: "e4pzv7p0"
}))(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.selectors.color(_constants.TEXT_COLOR);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.selectors.fontWeight('medium');
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.selectors.color(_constants.TEXT_COLOR);
}, function (_ref4) {
  var theme = _ref4.theme;
  return "2px solid ".concat(theme.selectors.color(_constants.TEXT_COLOR));
}, function (_ref5) {
  var theme = _ref5.theme;
  return (0, _utils.darken)(theme.selectors.color(_constants.TEXT_COLOR), 0.05);
});
MessageBannerText.defaultProps = (0, _objectSpread2.default)({}, _text.Text.defaultProps, {
  color: _constants.TEXT_COLOR,
  fontSize: _constants.FONT_SIZE
});
MessageBannerText.displayName = 'MessageBannerText';
var _default = MessageBannerText;
exports.default = _default;